import { HttpModelConverter } from "src/app/modules/core/converter/httpModel.converter";
import { Injectable } from "@angular/core";
import { CommunicationConfigurationEmailSenderModel } from "../communicationConfigurationEmailSender.model";
import { CommunicationConfigurationEmailSenderSummaryConverter } from "./communicationConfigurationEmailSenderSummary.converter";
@Injectable({
    providedIn: "root"
})
export class CommunicationConfigurationEmailSenderConverter extends HttpModelConverter<CommunicationConfigurationEmailSenderModel> {
    constructor(private senderSummaryConverter: CommunicationConfigurationEmailSenderSummaryConverter) {
        super();
    }
    protected createInstance(): CommunicationConfigurationEmailSenderModel {
        return new CommunicationConfigurationEmailSenderModel();
    }
    protected enrichObject(result: CommunicationConfigurationEmailSenderModel, src: CommunicationConfigurationEmailSenderModel): void {
        result.summary = this.senderSummaryConverter.convert(src.summary);
    }
}